import { render, staticRenderFns } from "./SignatureCanvas.vue?vue&type=template&id=43e86ed0&scoped=true"
import script from "./SignatureCanvas.vue?vue&type=script&lang=js"
export * from "./SignatureCanvas.vue?vue&type=script&lang=js"
import style0 from "./SignatureCanvas.vue?vue&type=style&index=0&id=43e86ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e86ed0",
  null
  
)

export default component.exports